<template>
  <!-- Manage members requests -->
  <ion-row v-if="isAdmin && group.join_requests.length > 0" class="ion-no-padding ion-no-pargin">
    <ion-col class="ion-no-padding ion-no-pargin">
      <ion-item class="ion-no-padding ion-no-pargin" no-lines lines="none">
        <ion-label class="left-margin-15px"><b>Join Requests</b></ion-label>
      </ion-item>
        <manage-join-requests :group="group" :refreshSettingCallback="refreshSettingCallback"></manage-join-requests>
    </ion-col>
  </ion-row>
  <!-- Manage members -->
  <ion-row class="ion-no-padding ion-no-pargin">
    <ion-col class="ion-no-padding ion-no-pargin">
      <ion-item class="ion-no-padding ion-no-pargin" no-lines lines="none">
        <ion-label v-if="isAdmin" class="left-margin-15px"><b>Manage Members</b></ion-label>
        <ion-label v-if="!isAdmin" class="left-margin-15px"><b>Group Members</b></ion-label>
      </ion-item>
        <manage-group-members :group="group" :refreshSettingCallback="refreshSettingCallback"></manage-group-members>
    </ion-col>
  </ion-row>
  <!-- Invite members -->
  <ion-row v-if="isAdmin" class="ion-no-padding ion-no-pargin">
    <ion-col class="ion-no-padding ion-no-pargin">
      <ion-item class="ion-no-padding ion-no-pargin" no-lines lines="none">
        <ion-label class="left-margin-15px"><b>Invite Members</b></ion-label>
      </ion-item>
        <group-member-invite :group="group" :invitedMembers="invitedMembers"></group-member-invite>
    </ion-col>
  </ion-row>
  <ion-row v-if="isAdmin" class="ion-no-padding ion-no-pargin">
    <ion-col class="ion-no-padding ion-no-pargin">
      <ion-button
        size="medium"
        expand="full"
        @click="deactivateTheGroup(group)"
        class="ion-no-padding ion-no-pargin"  
      >
        Delete Group
      </ion-button>
    </ion-col>
  </ion-row>
  <br/>
</template>

<script>
import {
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonButton,
  toastController,
  alertController,
} from "@ionic/vue";
import { useRouter } from "vue-router";
import {
  arrowBackOutline,
} from "ionicons/icons";

import {
  isMobileScreen,
  getColSize,
  getOffsetSize,
} from "../../services/utils";

import { deactivateGroup, inviteRequestList } from "../../services/apiCall";

import GroupMemberInvite from "./GroupMemberInvite.vue";
import ManageGroupMembers from "./ManageGroupMembers.vue";
import ManageJoinRequests from "./ManageJoinRequests.vue";

export default {
  name: "GroupSettings",
  props: ["group", "refreshOverviewCallback"],
  mounted() {
    this.init();
  },
  components: {
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonButton,
    GroupMemberInvite,
    ManageGroupMembers,
    ManageJoinRequests,
  },
  setup() {
    const router = useRouter();
    return {
      router,
      getColSize,
      getOffsetSize,
      isMobileScreen,
      deactivateGroup,
      inviteRequestList,
      arrowBackOutline,
    };
  },
  data() {
    return {
      form: {
        groupName: "",
        groupDescription: "",
        groupVisibility: "Closed",
        groupMemberJoining: "Request",
        groupSearchable: false,
      },
      newGroupClicked: false,
      invitedMembers: [],
      isUpdateGroupVisible: false,
    };
  },
  computed: {
    strings() {
      return this.$store.getters.strings;
    },
    user() {
      return this.$store.getters.user;
    },
    currentGroupMember() {
      return this.$store.getters.currentGroupMember;
    },
    isAdmin() {
      return (
        this.group.info.is_group_member &&
        this.group.info.group_member_type === "Admin"
      );
    },
  },
  methods: {
    init() {
      console.log("GROUP=>", this.group);
      this.form.groupName = this.group.info.group_name;
      this.form.groupDescription = this.group.info.description;
      this.form.groupVisibility = this.group.info.visibility_type;
      this.form.groupMemberJoining = this.group.info.joining_by;
      this.form.groupSearchable = this.group.info.is_searchable;
      if (this.isAdmin) this.getInvitedMembers();
    },
    async openToast(msg) {
      const toast = await toastController.create({
        message: msg,
        duration: 1500,
      });
      return toast.present();
    },
    async deactivateTheGroup(group) {
      console.log("deactivateGroup (delete)", group);

      const anAlert = await alertController.create({
        title: "Confirm Delete Group",
        message:
          '<span style="text-align: justify; text-justify: inter-word;">Deleting a group cannot be undone.<br/><small>For regulatory requirement, your group content may still be archived for sometime as per local laws.</small><br/><br/><b>Do you really want to delete the group?</b></span>',
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              console.log("Cancel clicked");
            },
          },
          {
            text: "Confirm",
            handler: () => {
              deactivateGroup({ group_id: group.group_id })
                .then((res) => {
                  if (res.data.status === 0) {
                    group.is_deactivated = true;
                    group.deactivated_message = "You have delete this Group.";
                    this.openToast(group.deactivated_message);
                    this.router.replace("/groups");
                  } else {
                    this.openToast(res.data.error.error_message);
                  }
                })
                .catch((err) => {
                  console.log("deactivateGroup - delete - err", err);
                });
            }, // end handler
          },
        ],
      });
      await anAlert.present();
    },
    getInvitedMembers() {
      console.log('getInvitedMembers', this.group.info);
      inviteRequestList({ group_id: this.group.info.id }).then((res) => {
        console.log("getInvitedMembers:", res);
        if (res.data.status === 0) {
          this.invitedMembers = res.data.result.invite_list;
        } else {
          console.log("getInvitedMembers - err1");
        }
      }).catch((err) => {
        console.log("getInvitedMembers - err2", err);
      });
    },
    refreshSettingCallback() {
      this.refreshOverviewCallback();
    }
  },
};
</script>